import React from "react";
import { IconType } from "./types";

const Truck: IconType = (props) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M45.2807 46.0366C47.1907 46.0366 48.739 44.4882 48.739 42.5783C48.739 40.6683 47.1907 39.1199 45.2807 39.1199C43.3707 39.1199 41.8224 40.6683 41.8224 42.5783C41.8224 44.4882 43.3707 46.0366 45.2807 46.0366Z"
      stroke="black"
      strokeWidth="1.25"
      strokeMiterlimit="10"
    />
    <path
      d="M47.5755 32.5288H40.8525C40.6063 32.5283 40.3704 32.4302 40.1965 32.256C40.0225 32.0818 39.9249 31.8457 39.9249 31.5995V25.2134C39.9249 24.9674 40.0226 24.7314 40.1966 24.5574C40.3705 24.3835 40.6065 24.2857 40.8525 24.2857H43.8145C44.0261 24.2854 44.2344 24.338 44.4205 24.4386C44.6067 24.5392 44.7648 24.6847 44.8804 24.8619L48.9181 30.0469C49.0761 30.2889 49.1658 30.5691 49.1778 30.8579C49.1897 31.1467 49.1234 31.4334 48.9858 31.6876C48.8483 31.9418 48.6446 32.1542 48.3964 32.3023C48.1482 32.4503 47.8645 32.5286 47.5755 32.5288V32.5288Z"
      stroke="black"
      strokeWidth="1.25"
      strokeMiterlimit="10"
    />
    <path
      d="M16.9972 17.3333L13.4022 21.109L17.0607 24.9009"
      stroke="black"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M13.923 20.9902L37.5031 20.9625H43.8859C44.3794 20.9626 44.866 21.0771 45.3077 21.2971C45.7494 21.5171 46.134 21.8365 46.4313 22.2303L53.6832 31.8436L54.256 32.4686C54.9508 33.2221 55.3356 34.2102 55.3334 35.2352V39.5675C55.3334 40.3224 55.0335 41.0464 54.4997 41.5802C53.9659 42.114 53.2419 42.4139 52.487 42.4139H48.6234"
      stroke="black"
      strokeWidth="1.25"
      strokeMiterlimit="10"
    />
    <path
      d="M24.0229 42.077H41.907"
      stroke="black"
      strokeWidth="1.25"
      strokeMiterlimit="10"
    />
    <path
      d="M16.8622 42.1307H11.6544"
      stroke="black"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M27.4667 35.9464H15.0981"
      stroke="black"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M22 32L8.66669 32"
      stroke="black"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M20.5403 46.0366C22.4503 46.0366 23.9986 44.4882 23.9986 42.5783C23.9986 40.6683 22.4503 39.1199 20.5403 39.1199C18.6303 39.1199 17.082 40.6683 17.082 42.5783C17.082 44.4882 18.6303 46.0366 20.5403 46.0366Z"
      stroke="black"
      strokeWidth="1.25"
      strokeMiterlimit="10"
    />
  </svg>
);

export default Truck;
